const locale = {
  'importModal.title': '批量导入',
  'importModal.button.upload': '上传文件',
  'importModal.message.parseError': '解析文件失败',
  'importModal.table.updatedFieldName': '可更新列',
  'importModal.table.fileColumnTitle': '文件列',
  'importModal.table.previewValue': '数据预览',
  'importModal.table.defaultValue': '默认值',
  'importModal.select.placeholder': '请选择',
  'importModal.input.placeholder': '请输入',
  'importModal.button.downloadTemplate': '下载模版',
};

export default locale;
